import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import { tokens } from "../theme";
import React from "react";
import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/Attachment";
import NoDataFound from "./NoDataFound";
import Paper from "@mui/material/Paper";
import { formatPrice } from "../utils/PriceFormatter";
import { ERROR_FOUND_DURING_API_CALL, ERROR_WHILE_FETCHING_DATA, LOADING_PLEASE_WAIT, PROCESSING_PLEASE_WAIT } from "../constants/Strings";
import { initializeEncryption } from "../services/AesGcmEncryption";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { LOGIN_ID, MESSAGE_KEY, SESSION_ID, USER_NAME } from "../constants/LocalStorageKeyValuePairString";
import { ApiErrorCode, ApiType } from "../services/ApiTags";
import { generateRequestId } from "../utils/RequestIdGenerator";
import { downloadPdfViewerData, getAttachmentInfo, getPayoutErrorDetails } from "../services/ApiService";
import { LOGIN } from "../constants/Constant";
import { useNavigate } from "react-router-dom";
import DebugLog from "../utils/DebugLog";
import FileDialog from "./FileDialog";
import PdfViewerDialog from "../scenes/exclusion/PdfViewerDialog";
import CustomProgressDialog from "./CustomProgressDialog";
import { ErrorOutlineTwoTone } from "@mui/icons-material";
import PayoutErrorDetailsDialog from "./PayoutErrorDetailsDialog";






const SimpleTable = ({
  loading,
  data,
  statusData,
  onRowClicked,
  totalNoOfPages,
  onPageChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

 
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const pageCount = totalNoOfPages ? totalNoOfPages : 1;


  const navigate = useNavigate();
  let blob;
  let filename;
  let url;
  const [open, setOpen] = useState(false);
  const [openPayoutErrorDialog, setOpenPayoutErrorDialog] = useState(false);
  const [openFileDialog, setFileDialogOpen] = useState(false);
  const [openPayoutErrorFileDialog, setPayoutErrorDialogOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [commentData, setComment] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [loadProgress, setLoading] = useState(false);


const MoreOptionsButton = ({ row }) => {
  const companyCode = row
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option, event) => {
    event.stopPropagation();
    getAttachmentDetails(row);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(event) => event.stopPropagation()} // Prevent row click even inside the menu
      >
        <MenuItem onClick={(event) => handleOptionClick("Download", event)}>
          Get Attachments Details
        </MenuItem>
        {/* <MenuItem onClick={(event) => handleOptionClick("View", event)}>
          View Attachment
        </MenuItem> */}
      </Menu>
    </>
  );
};



const PayoutErrorOptionsButton = ({ row }) => {
 // const batchNo = row
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option, event) => {
    event.stopPropagation();
    getPayoutErrorDetail(row);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <ErrorOutlineTwoTone sx={{ color: "red" }}/>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(event) => event.stopPropagation()} // Prevent row click even inside the menu
      >
        <MenuItem onClick={(event) => handleOptionClick("Download", event)}>
          Get Payout Error Details
        </MenuItem>
        {/* <MenuItem onClick={(event) => handleOptionClick("View", event)}>
          View Attachment
        </MenuItem> */}
      </Menu>
    </>
  );
};

function getPayoutErrorDetail(batchNo) {
  try {
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true);

      const requestObject = {
        pageNumber: "0",
        pageSize: "100",
        batchNo: batchNo+"",
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_PAYOUT_ERROR_DETAILS
      ).then((encryptedContentData) => {
        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          contentData: encryptedContentData,
        };

        getPayoutErrorDetails(requestData)
          .then((response) => {
            setLoading(false);
              if(response.data.result.content!==null){
                setFiles(response.data.result.content)
                setPayoutErrorDialogOpen(true)
              }else{
                alert("No Record Found!")
              }
           
           
          })
          .catch((error) => {
            setLoading(false);
            if (
              error !== null &&
              error !== undefined &&
              error.data !== null &&
              error.data !== undefined &&
              error.data.errorCode != null &&
              error.data.errorCode !== undefined &&
              error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
            ) {
              navigate(LOGIN);
            } else if (
              error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
            ) {
              try {
                navigate("/");
              } catch (error) {
                DebugLog("error " + error);
              }
            } else {
              const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : "Unknown";

              if (message)
                alert(
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
            }
          });
      });
  } catch (error) {
    const message = error.response != null ? error.response : error.message;
    alert(
      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
    );
  }
}


function getAttachmentDetails(referenceId) {
  try {
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true);

      const requestObject = {
        attachmentType: "ON_HOLD_AND_PAYOUT_SERVICE",
        reference: referenceId+"",
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_ATTACHMENT_INFO
      ).then((encryptedContentData) => {
        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          contentData: encryptedContentData,
        };

        getAttachmentInfo(requestData)
          .then((response) => {
            setLoading(false);
              if(response.data.result.attachments!==null){
                setFiles(response.data.result.attachments)
                setFileDialogOpen(true)
              }else{
                alert("No Attachment Found!")
              }
           
           
          })
          .catch((error) => {
            setLoading(false);
            if (
              error !== null &&
              error !== undefined &&
              error.data !== null &&
              error.data !== undefined &&
              error.data.errorCode != null &&
              error.data.errorCode !== undefined &&
              error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
            ) {
              navigate(LOGIN);
            } else if (
              error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
            ) {
              try {
                navigate("/");
              } catch (error) {
                DebugLog("error " + error);
              }
            } else {
              const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : "Unknown";

              if (message)
                alert(
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
            }
          });
      });
  } catch (error) {
    const message = error.response != null ? error.response : error.message;
    alert(
      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
    );
  }
}

  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value - 1); // Index starts from 0 for data array
  };

  const renderLoadingOrNoDataView = () => {
    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "10vh",
          }}
        >
          <CircularProgress />
        </div>
      );
    } else {
      return <NoDataFound />;
    }
  };

  const getColorForStatus = (status) => {
    const lowerCaseStatus = status.toLowerCase(); // Convert status to lower case

    if (lowerCaseStatus.includes("completed")) {
      return colors.greenAccent[400];
    } else if (lowerCaseStatus.includes("scheduled")) {
      return colors.primary[200];
    } else if (lowerCaseStatus.includes("cancel")) {
      return colors.grey[200];
    } else {
      return colors.primary[100]; // Default color if status doesn't match any case
    }
  };

  if (!data || data.length === 0) {
    return (
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} borderRadius={2}>
        <TableContainer sx={{ borderRadius: "0 0 8px 8px" }}>
          <Table
            sx={{ background: "transparent", minWidth: 650 }}
            aria-label="simple table"
            component={Paper}
          >
            <TableHead
              sx={{
                background: "rgba(255,255,255,0.6)",
                color: "#FF2300 !important",
                textTransform: "uppercase",
              }}
            >
              <TableRow sx={{ letterSpacing: "1px" }}>
                <TableCell sx={{ paddingLeft: "28px" }}>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Cut Off</TableCell>
                <TableCell>Payout By</TableCell>
                <TableCell align="right" sx={{ paddingRight: "28px" }}>
                  Payout
                </TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>

        {renderLoadingOrNoDataView()}
      </Grid>
    );
  }

  const openAttachment = (referenceId, attachmentType) => {
    let requestData;
    try {
      //if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        if (
          attachmentType !== null &&
          attachmentType !== undefined &&
          attachmentType !== ""
        ) {
          requestData = {
            attachmentType: attachmentType,
            referenceId: referenceId,
          };
        } else {
          requestData = {
            attachmentType: "FREEZE_ACCOUNTS",
            referenceId: referenceId,
          };
        }

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EXCLUSION_FILE_READ
        ).then((encryptedContentData) => {
          const addExclusionRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          downloadPdfViewerData(addExclusionRequestData)
            .then((response) => {
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];
              const type = contentType.split("/")[1];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    alert( jsonObject.displayErrorMessage);
                  } else {
                    alert( jsonObject.errorDescription);
                  }
                }
              } else {
                let fileBlob;
                switch (mimeType) {
                  case "image/png":
                    blob = new Blob([response.data], { type: "image/png" });
                    filename = referenceId + ".png";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/png" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpeg":
                    blob = new Blob([response.data], { type: "image/jpeg" });
                    filename = referenceId + ".jpeg";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/jpeg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpg":
                    blob = new Blob([response.data], { type: "image/jpg" });
                    filename = referenceId + ".jpg";
                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);
                    // fileBlob = new Blob([blob], { type: "image/jpg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "application/pdf":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = referenceId + ".pdf";
                    url = URL.createObjectURL(blob);
                    setImageUrl(null);
                    setPdfData(url);
                    setOpen(true);
                    break;

                  default:
                    break;
                }

                if (
                  mimeType !== "application/pdf" &&
                  mimeType !== "image/jpg" &&
                  mimeType !== "image/jpeg" &&
                  mimeType !== "image/png"
                ) {
                  alert( "File type is not supported!");
                }
              }
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  alert(
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      // } else {
      //   showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      // }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      alert(
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }

  const downloadPreviedFile = () => {

  };
  
  const handleClose = () => {
    setOpen(false);
    setFileDialogOpen(false);
  };
  const handlePayoutErrorDialogClose = () => {
    setOpenPayoutErrorDialog(false);
    setPayoutErrorDialogOpen(false);
  };

  return (
    <Box  sx={{
      width: '100vw',    // Full width of the viewport
      
    }}>
   
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} borderRadius={2}>
      <TableContainer sx={{ borderRadius: "0 0 8px 8px" }}>
        <Table
          sx={{ background: "transparent", minWidth: 750 }}
          aria-label="simple table"
          component={Paper}
        >
          <TableHead
            sx={{
              background: "rgba(255,255,255,0.6)",
              color: "#FF2300 !important",
              textTransform: "uppercase",
            }}
          >
            <TableRow sx={{ letterSpacing: "1px" }}>
              <TableCell sx={{ paddingLeft: "28px" }}>Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Cut Off</TableCell>
              <TableCell>Payout By</TableCell>
              <TableCell align="right" sx={{ paddingRight: "28px" }}>
                Payout
              </TableCell>
              {/* <TableCell>Action</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody sx={{ background: "rgba(255,255,255,1)" }}>
            {data.map((payoutSummaryList) => (
              <TableRow
                key={payoutSummaryList.id}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                  textDecoration: "none !important",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#f5f5f5", // change background color on hover
                  },
                }}
                
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    paddingLeft: "28px",
                    fontSize: 14,
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    onRowClicked(
                      payoutSummaryList.displayName,
                      payoutSummaryList.batchNo,
                      payoutSummaryList.version,
                      payoutSummaryList.commissionType,
                      payoutSummaryList.showApproval,
                      payoutSummaryList.showCancel,
                      payoutSummaryList.showHold,
                      payoutSummaryList.showRelease,
                      payoutSummaryList.showRequestApproval,
                      payoutSummaryList.showRequestRelease
                    );
                  }
                }
                >
                  {payoutSummaryList.displayName}
                </TableCell>
                <TableCell
                  sx={{
                    color: getColorForStatus(payoutSummaryList.payoutStatus),
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                  onClick={() => {
                    onRowClicked(
                      payoutSummaryList.displayName,
                      payoutSummaryList.batchNo,
                      payoutSummaryList.version,
                      payoutSummaryList.commissionType,
                      payoutSummaryList.showApproval,
                      payoutSummaryList.showCancel,
                      payoutSummaryList.showHold,
                      payoutSummaryList.showRelease,
                      payoutSummaryList.showRequestApproval,
                      payoutSummaryList.showRequestRelease
                    );
                  }
                }
                >
                  <Grid
                    container
                    direction={"row"}
                    alignItems={"center"}
                    spacing={1.5}
                  >
                    <Grid item>
                      <Box
                        width={6}
                        height={6}
                        borderRadius={6}
                        backgroundColor={getColorForStatus(
                          payoutSummaryList.payoutStatus
                        )}
                        sx={{
                          display: {
                            xs: "none",
                            sm: "flex",
                          },
                        }}
                      ></Box>
                    </Grid>
                    <Grid item>{payoutSummaryList.payoutStatus}</Grid>
                  </Grid>
                </TableCell>
                <TableCell onClick={() => {
                  onRowClicked(
                    payoutSummaryList.displayName,
                    payoutSummaryList.batchNo,
                    payoutSummaryList.version,
                    payoutSummaryList.commissionType,
                    payoutSummaryList.showApproval,
                    payoutSummaryList.showCancel,
                    payoutSummaryList.showHold,
                    payoutSummaryList.showRelease,
                    payoutSummaryList.showRequestApproval,
                    payoutSummaryList.showRequestRelease
                  );
                }
              }>{payoutSummaryList.cutOffDate}</TableCell>
                <TableCell onClick={() => {
                  onRowClicked(
                    payoutSummaryList.displayName,
                    payoutSummaryList.batchNo,
                    payoutSummaryList.version,
                    payoutSummaryList.commissionType,
                    payoutSummaryList.showApproval,
                    payoutSummaryList.showCancel,
                    payoutSummaryList.showHold,
                    payoutSummaryList.showRelease,
                    payoutSummaryList.showRequestApproval,
                    payoutSummaryList.showRequestRelease
                  );
                }
              }>{payoutSummaryList.payOutDate}</TableCell>
                <TableCell
                  align="right"
                  sx={{
                    paddingRight: "28px",
                    fontSize: 15,
                    fontWeight: 900,
                  }}
                  onClick={() => {
                    onRowClicked(
                      payoutSummaryList.displayName,
                      payoutSummaryList.batchNo,
                      payoutSummaryList.version,
                      payoutSummaryList.commissionType,
                      payoutSummaryList.showApproval,
                      payoutSummaryList.showCancel,
                      payoutSummaryList.showHold,
                      payoutSummaryList.showRelease,
                      payoutSummaryList.showRequestApproval,
                      payoutSummaryList.showRequestRelease
                    );
                  }
                }
                >
                  RM {formatPrice(payoutSummaryList.summaryAmount)}
                </TableCell>
               
                <TableCell>
                  <MoreOptionsButton row={payoutSummaryList.batchNo} />{" "}
                  {/* see attachment button */}
                </TableCell>

                {payoutSummaryList.payoutStatus ==='Error' ? (
                <TableCell>
                  <PayoutErrorOptionsButton row={payoutSummaryList.batchNo} />{" "}
                  {/* payout error button */}
                </TableCell>
               ) : ""}
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* <TablePagination
          component="div"
          count={count}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        /> */}
      </TableContainer>

      {totalNoOfPages > 1 && (
        <>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ marginTop: 2 }}
          >
            <Pagination
              count={pageCount}
              page={currentPage}
              onChange={(event, value) => handlePageChange(value)}
            />
          </Box>

          <Typography sx={{ marginLeft: 2, marginBottom: 2 }}>
            <span>Jump to page: </span>
            <select
              value={currentPage}
              onChange={(event) => handlePageChange(Number(event.target.value))}
              sx={{ marginRight: 2 }}
            >
              {[...Array(pageCount)].map((_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </select>
          </Typography>
        </>
      )}
    </Grid>
<PayoutErrorDetailsDialog
open={openPayoutErrorFileDialog}
onClose={handlePayoutErrorDialogClose}
files={files}
previewFile={openAttachment}
type={"PAYOUT_ERROR_DETAILS_SERVICE"}
/>

     <FileDialog
    open={openFileDialog}
    onClose={handleClose}
    files={files}
    previewFile={openAttachment}
    type={"ON_HOLD_AND_PAYOUT_SERVICE"}
  />
 <CustomProgressDialog open={loadProgress} text={getProgressbarText} />
  <PdfViewerDialog
    open={open}
    handleClose={handleClose}
    downloadPdf={downloadPreviedFile}
    pdfUrl={pdfData}
    imageUrl={imageUrl}
    comment={commentData}
  ></PdfViewerDialog>
    </Box>
  );
};

export default SimpleTable;
